import React from "react";
import Typography from "@material-ui/core/Typography";
import {version} from '../package.json'

class VersionInfo extends React.Component {
    render() {

        const versionStyle = {
            verticalAlign: 'text-bottom',
            fontSize: '8px'
        };
        return (

            <Typography align={"center"} style={versionStyle} variant='caption'> {version}</Typography>
        )
    }
}

export default VersionInfo;
